import tpaSessionStorage from '@wix/podcasts-common/dist/tpaSessionStorage';

import router, { RouterEvent } from '../router/router';

function syncWidgetPageWithSettingsApp() {
  // NOTE: save widget page, to allow settings app know what page is opened in widget
  const unsubscribeRouteChanged = router.on(
    RouterEvent.ROUTE_CHANGE_COMPLETED,
    ({ route }) => {
      tpaSessionStorage.set('widgetPage', route.page);
    },
  );

  return () => {
    unsubscribeRouteChanged();
  };
}

export default syncWidgetPageWithSettingsApp;
